export default "__VITE_ASSET__C3ZIGADX__"